"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CompanyMission() {
  const {
    ref: topTextRef,
    isVisible: isTopVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: bottomContentRef,
    isVisible: isBottomVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="254133" id="the-studio-vision" className="dark bg-background text-foreground overflow-hidden">
      {}
      <div className="container mx-auto px-6 py-24 md:py-[120px] flex justify-center items-center min-h-[50vh]">
        <h2 ref={topTextRef} className={`text-2xl md:text-4xl lg:text-5xl font-default font-light text-center max-w-5xl leading-tight md:leading-snug tracking-tight transition-all duration-1000 ease-out ${isTopVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          Ivory Lens is a contemporary wedding photography studio dedicated to capturing the quiet, timeless moments that define your unique love story.
        </h2>
      </div>

      {}
      <div className="relative w-full bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/ivory_lens_studio_interior.png)]">
        {}
        <div className="absolute inset-0 bg-background/80 backdrop-blur-[4px]"></div>
        
        <div className="container relative z-10 mx-auto px-6 py-24 md:py-[120px]">
          <div ref={bottomContentRef} className={`grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 transition-all duration-1000 delay-300 ease-out ${isBottomVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <div className="md:col-span-4 lg:col-span-5">
              <h3 className="text-sm md:text-base font-default tracking-widest text-primary uppercase">
                The Philosophy
              </h3>
            </div>

            {}
            <div className="md:col-span-8 lg:col-span-7 max-w-3xl space-y-8">
              <p className="text-lg md:text-2xl font-default font-light leading-relaxed text-foreground/90 italic">
                <span className="text-5xl md:text-7xl float-left mr-4 mt-2 font-default leading-none text-primary">W</span>e believe in refined nostalgia—the art of creating imagery that feels as evocative fifty years from now as it does today. Our approach blends artistic composition with the soft, natural light of fine-art film.
              </p>
              <p className="text-lg md:text-2xl font-default font-light leading-relaxed text-foreground/90">
                By focusing on personalized service and the subtle emotional weight of every frame, we deliver a seamless experience that transforms your wedding day into a beautifully curated visual legacy.
              </p>
              
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}